module.exports = __webpack_public_path__ + "03_long_brown.84e0b192.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/03_long_brown.png
// module id = 4QF3
// module chunks = 0